export enum AuthMatch {
  ALL = 'all',
  SOME = 'some',
  NONE = 'none',
}
